import React from "react";
import Loadable from "react-loadable";
import Loading from "components/Loading";

import { AppSettings } from "../constants";
import CreateNewLot from "./Containers/manage-create-new-lot";
import AddIndividualLot from "./Containers/add-individual-lot";
import ImportExcelLot from "./Containers/import-excel-lot";
import LotDetail from "./Containers/lot-view";
import HomeownerManageLot from "./Containers/lot-list";
import Translate from "components/translate";
import DigitalHomeLibrary from "./Containers/home-hub";
import HomeownerIntro from "../portal_homeowner/intro";
import HomeOwnerMaintainance from "./Containers/homeowner-maintaince";
import HomeOwnerInventory from "./Containers/homeowner-inventory";
import homeownerDocuments from "./Containers/homeowner-documents";
import homeownerProperty from "./Containers/homeowner-property";
import HomeCare from "../HomeCare/Containers/home-hub-home-care";

const HomeownerAddRequest = Loadable({
  loader: () => import("./Containers/lot-view-rfs-list-add"),
  loading: Loading,
});

const HomeownerAddProblem = Loadable({
  loader: () => import("./Containers/add-new-problem"),
  loading: Loading,
});

const HomeownerManual = Loadable({
  loader: () => import("./Containers/home-hub"),
  loading: Loading,
});

export default [
  {
    path: "/lots/add-individual-lot/:projectId/:isNew",
    component: AddIndividualLot,
    private: true,
  },
  {
    path: "/lots/import-excel-lot/:projectId/:isNew",
    component: ImportExcelLot,
    private: true,
  },
  {
    path: "/lots",
    component:
      AppSettings.clientTypeValue === "Homeowner"
        ? HomeownerManageLot
        : CreateNewLot,
    private: true,
    portal: ["Builder", "Homeowner"],
    menu: {
      name: <Translate translateKey="lot" plurals capitalize />,
      order: 3,
      className:
        AppSettings.clientTypeValue !== "Homeowner" ? "menu-divide" : "",
      icons: "icon-lots-ic",
      condition: () => {
        return (
          AppSettings.CURRENT_SITE_URI !== AppSettings.SITE_ONE_SERVICE_URI
        );
      },
    },
  },

  {
    path: "/property",
    component:
      AppSettings.clientTypeValue === "Homeowner"
        ? homeownerProperty
        : CreateNewLot,
    private: true,
    portal: ["Homeowner"],
    menu: {
      name: "Properties",
      order: 4,
      className:
        AppSettings.clientTypeValue !== "Homeowner" ? "menu-divide" : "",
      icons: "fa fa-th-large",
      condition: () => {
        return AppSettings.clientTypeValue === "Homeowner";
      },
    },
  },
  {
    path: "/documents",
    component:
      AppSettings.clientTypeValue === "Homeowner" ? homeownerDocuments : "",
    private: true,
    portal: ["Homeowner"],
    menu: {
      name: "Documents",
      order: 5,
      className:
        AppSettings.clientTypeValue !== "Homeowner" ? "menu-divide" : "",
      icons: "fa fa-file-text-o",
      condition: () => {
        return AppSettings.clientTypeValue === "Homeowner";
      },
    },
  },
  {
    path: "/lots/:lotId",
    component: LotDetail,
    private: true,
  },
  {
    path: "/lot/:LOTID/request/add",
    component: HomeownerAddRequest,
    private: true,
    portal: ["Homeowner"],
  },
  {
    path: "/lot/:LOTID/request/:REQUESTID/problem/add",
    component: HomeownerAddProblem,
    private: true,
    portal: ["Homeowner"],
  },

  {
    path: "/inventory",
    component: HomeOwnerInventory,
    private: true,
    portal: ["Homeowner"],
    menu: {
      name: "Inventory",
      order: 6,
      icons: "fa fa-shopping-cart",
      condition: () => {
        return AppSettings.clientTypeValue === "Homeowner";
      },
    },
  },
  {
    path: "/home-maintenance",
    component: HomeOwnerMaintainance,
    private: true,
    portal: ["Homeowner"],
    menu: {
      name: "Maintenance",
      order: 7,
      icons: "fa fa-wrench",
      condition: () => {
        return AppSettings.clientTypeValue === "Homeowner";
      },
    },
  },
  {
    path: "/home-care",
    component: HomeCare,
    private: true,
    portal: ["Homeowner"],
    menu: {
      name: "Home Care",
      order: 7,
      icons: "fa fa-lightbulb-o",
      condition: () => {
        return AppSettings.clientTypeValue === "Homeowner";
      },
    },
  },

  // ...(localStorage.getItem(AppSettings.IS_SSO_USER) === 'True' &&AppSettings.clientTypeValue === 'Homeowner'?
  // [{
  //   path: '/',
  //   component: HomeownerManageLot,
  //   private: true,
  //   portal: ['Homeowner'],
  //   // menu: {
  //   //   name: 'Welcome',
  //   //   order: 1,
  //   //   icons: 'pe-7s-compass',
  //   //   condition: () => {
  //   //     return AppSettings.clientTypeValue === 'Homeowner';
  //   //   },
  //   // },
  // }]
  // :
  // [
  //   {
  //     path: '/',
  //     component: HomeownerIntro,
  //     private: true,
  //     portal: ['Homeowner'],
  //     menu: {
  //       name: 'Welcome',
  //       order: 1,
  //       icons: 'pe-7s-compass',
  //       condition: () => {
  //         return AppSettings.clientTypeValue === 'Homeowner'&&localStorage.getItem(AppSettings.IS_SSO_USER) === 'False';
  //       },
  //     },
  //   }
  // ])
];

// export default [
//   {
//     path: "/lots",
//     component:
//       AppSettings.clientTypeValue === 'Homeowner'
//         ? HomeownerManageLot
//         : CreateNewLot,
//     private: true,
//     portal: ['Builder','Homeowner'],
//     menu: {
//       name: <Translate translateKey='Properties' plurals capitalize />,
//       order: 2,
//       className:
//         AppSettings.clientTypeValue !== 'Homeowner' ? 'menu-divide' : '',
//       icons: AppSettings.clientTypeValue === "Homeowner" ? <LuSquareLibrary /> : 'icon-lots-ic',
//       condition: () => {
//         return (
//           AppSettings.CURRENT_SITE_URI !== AppSettings.SITE_ONE_SERVICE_URI
//         );
//       },
//     },
//   },
//   // {
//   //   path: "/home-hub",
//   //   component: DigitalHomeLibrary,
//   //   private: true,
//   //   portal: ["Homeowner"],
//   //   menu: {
//   //     name: "Documents",
//   //     order: 3,
//   //     icons: <IoDocumentTextOutline />,
//   //     condition: () => {
//   //       return (
//   //         AppSettings.clientTypeValue === "Homeowner" &&
//   //         localStorage.getItem(AppSettings.IS_SSO_USER) === "False"
//   //       );
//   //     },
//   //   },
//   // },
//   // {
//   //   path: "/home-hub",
//   //   component: DigitalHomeLibrary,
//   //   private: true,
//   //   portal: ["Homeowner"],
//   //   menu: {
//   //     name: "Inventory",
//   //     order: 4,
//   //     icons: <IoCartOutline />,
//   //     condition: () => {
//   //       return (
//   //         AppSettings.clientTypeValue === "Homeowner" &&
//   //         localStorage.getItem(AppSettings.IS_SSO_USER) === "False"
//   //       );
//   //     },
//   //   },
//   // },
//   // {
//   //   path: "",
//   //   component: HomeownerIntro,
//   //   private: true,
//   //   portal: ["Homeowner"],
//   //   menu: {
//   //     name: "Finance",
//   //     order: 5,
//   //     icons: <BiCoinStack />,
//   //     condition: () => {
//   //       return (
//   //         AppSettings.clientTypeValue === "Homeowner" &&
//   //         localStorage.getItem(AppSettings.IS_SSO_USER) === "False"
//   //       );
//   //     },
//   //   },
//   // },
//   {
//     path: "/lots/add-individual-lot/:projectId/:isNew",
//     component: AddIndividualLot,
//     private: true,
//   },
//   {
//     path: "/lots/import-excel-lot/:projectId/:isNew",
//     component: ImportExcelLot,
//     private: true,
//   },

//   {
//     path: "/lots/:lotId",
//     component: LotDetail,
//     private: true,
//   },
//   {
//     path: '/lot/:LOTID/request/add',
//     component: HomeownerAddRequest,
//     private: true,
//     portal: ['Homeowner'],
//   },
//   {
//     path: '/lot/:LOTID/request/:REQUESTID/problem/add',
//     component: HomeownerAddProblem,
//     private: true,
//     portal: ['Homeowner'],
//   },
//   {
//     path: '/home-hub',
//     component: DigitalHomeLibrary,
//     private: true,
//     portal: ['Homeowner'],
//     menu: {
//       name: 'Home Hub',
//       order: 3,
//       icons:  <IoDocumentTextOutline />,
//       condition: () => {
//         return AppSettings.clientTypeValue === 'Homeowner'&&localStorage.getItem(AppSettings.IS_SSO_USER) === 'False'
//       },
//     },
//   },
//   // {
//   //   path: '/',
//   //   component: HomeownerIntro,
//   //   private: true,
//   //   portal: ['Homeowner'],
//   //   menu: {
//   //     name: 'Properties',
//   //     order: 4,
//   //     icons: 'icon-punch-lists-ic',
//   //     condition: () => {
//   //       return AppSettings.clientTypeValue === 'Homeowner'&&localStorage.getItem(AppSettings.IS_SSO_USER) === 'False'
//   //     },
//   //   },
//   // },
//   // ...(localStorage.getItem(AppSettings.IS_SSO_USER) === 'True' &&AppSettings.clientTypeValue === 'Homeowner'?
//   // [{
//   //   path: '/',
//   //   component: HomeownerManageLot,
//   //   private: true,
//   //   portal: ['Homeowner'],
//   //   // menu: {
//   //   //   name: 'Welcome',
//   //   //   order: 1,
//   //   //   icons: 'pe-7s-compass',
//   //   //   condition: () => {
//   //   //     return AppSettings.clientTypeValue === 'Homeowner';
//   //   //   },
//   //   // },
//   // }]
//   // :
//   // [
//   //   {
//   //     path: '/',
//   //     component: HomeownerIntro,
//   //     private: true,
//   //     portal: ['Homeowner'],
//   //     menu: {
//   //       name: 'Welcome',
//   //       order: 1,
//   //       icons: 'pe-7s-compass',
//   //       condition: () => {
//   //         return AppSettings.clientTypeValue === 'Homeowner'&&localStorage.getItem(AppSettings.IS_SSO_USER) === 'False';
//   //       },
//   //     },
//   //   }
//   // ])
// ];



// WEBPACK FOOTER //
// ./src/Lots/routes.js